@for (blockId of blockIdList; track blockId; let index = $index) {
  <app-block-factory
    [blockId]="$any(blockId)"
    [injectData]="injectData"
  />
}
